import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import './FourDotLoader.styles.scss';

type FourDotLoaderProps = {
  className?: string;
  asOverlay?: boolean;
};

const spanPositionClasses = ['first', 'hidden', 'third', 'second'];
const spanColorClasses = ['', 'color-one', 'color-two ', 'color-three'];
const PHASE_COUNT = 4;
const MAX_INDEX = PHASE_COUNT - 1;
const ANIMATION_TIME_MS = 330;

const getClassIndex = (index: number, phase: number) => {
  const dif = index - phase;
  return dif < 0 ? PHASE_COUNT + dif : dif;
};

const FourDotLoader: React.FC<FourDotLoaderProps> = (props) => {
  const { className, asOverlay = false } = props;
  const [currentPhase, setCurrentPhase] = useState(0);
  const [animationStartClass, setAnimationStartClass] = useState('');

  const classes = classNames(
    'four-dot-loader',
    { 'as-overlay': asOverlay },
    className,
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCurrentPhase((old) => (old < MAX_INDEX ? old + 1 : 0));
    }, ANIMATION_TIME_MS);

    return () => clearTimeout(timeout);
  }, [currentPhase]);

  useEffect(() => {
    setAnimationStartClass('apear');
  }, []);

  return (
    <div
      className={classes}
      style={
        { '--animation-time': `${ANIMATION_TIME_MS}ms` } as React.CSSProperties
      }
    >
      <div className={animationStartClass}>
        {Array(4)
          .fill(void 0)
          .map((_, index) => (
            <span
              key={index}
              className={classNames(
                spanColorClasses[index],
                spanPositionClasses[getClassIndex(index, currentPhase)],
              )}
            />
          ))}
      </div>
    </div>
  );
};

export default FourDotLoader;
